<template>
    <div class="d-modal-main">
        <div>
            <slot></slot>
        </div>
        <step-indicator class="text-right mt-2" v-if="stepIndicator" :wizard="stepIndicator"></step-indicator>
    </div>
</template>

<script>
import StepIndicator from './step-indicator.vue'

export default {
  components: { StepIndicator },
  props: ['step-indicator']
}
</script>



// WEBPACK FOOTER //
// src/components/login/modal/main.vue